define.alias("shared/components/shared/ui/search-box/result", "calendar/components/shared/ui/search-box/result");